export const environment = {
  production: true,
  api: 'https://syntenybrowser.jax.org/api',
  sourceCode: {
    etl: 'https://github.com/TheJacksonLaboratory/syntenybrowserv2-etl',
    client: 'https://github.com/TheJacksonLaboratory/syntenybrowserv2-client',
    api: 'https://github.com/TheJacksonLaboratory/syntenybrowserv2-api',
  },
  sourceData: 'http://www.informatics.jax.org/downloads/SyntenyBrowser/',
  cookieDomain: 'jax.org'
};
